import { render, staticRenderFns } from "./ListadoInscripcionesCompletas.vue?vue&type=template&id=54b8b6e1"
import script from "./ListadoInscripcionesCompletas.vue?vue&type=script&lang=js"
export * from "./ListadoInscripcionesCompletas.vue?vue&type=script&lang=js"
import style0 from "./ListadoInscripcionesCompletas.vue?vue&type=style&index=0&id=54b8b6e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports